import { Recurring } from './recurring.model';
import { MeetingType } from './meeting-type-model.model';
import { ViewMeetingsDetail } from './view-meeting.model';


export class MeetingManager {
    meetingTypeId: Number;
    meetingTitle = '';
    meetingDescription = '';
    startDate = '';
    startTime = '';
    endDate = '';
    endTime = '';
    staticEndDate = '';
    recurringType = '';
    recurring: Recurring = new Recurring();
    location = '';
    meetingId = 0;
    recurringId = 0;
    occuranceType = 0;
}

export class MeetingModel {
    selectedMeetingType: any;
    meetingTitle: string;
    meetingDescription: string;
    selectedStartDate: any; // Start Date Selection for Date Picker
    selectedEndsOnStaticDate: any; // Ends On Static Date Selection for Date Picker
    startTime: string;
    selectedEndDate: any; // End Date Selection for Date Picker
    endTime: string;
    selectedRepeat: number; // Selected option from repeat list
    location: string;
    selectedRepeatBy: number; // Selected Repeat By
    selectedRepeatEvery: string; // Selected option for repeat every
    selectedMonthlyOn: number; // Selected Monthly On Date/Day
    selectedRepeatOn: Array<any>; // Selected Repeat on
    selectedRepeatEnds: number; // Selected Repeat Ends 0 -> Never 1 -> On Date 2 -> After Occurrence
    selectedEndsOn:  Date; // Selected Ends on Date
    selectedEndsAfter: number ; // Selected value of Ends After Occurrence
    maxEndOn: any;

    constructor() {
        this.selectedMeetingType = 0; // Selected meeting type
        this.meetingTitle = '';
        this.meetingDescription = '';
        this.selectedStartDate = null; // Start Date Selection for Date Picke;
        this.selectedEndsOnStaticDate = null; // Ends On Static Date Selection for Date Picke;
        this.startTime = '';
        this.selectedEndDate = null; // End Date Selection for Date Picke;
        this.endTime = '';
        this.selectedRepeat = 0; // Selected option from repeat lis;
        this.location = '';
        this.selectedRepeatBy = 1; // Selected Repeat B;
        this.selectedRepeatEvery = 'timeGridWeek'; // Selected option for repeat ever;
        this.selectedMonthlyOn = 0; // Selected Monthly On Date/Da;
        this.selectedRepeatOn = []; // Selected Repeat o;
        this.selectedRepeatEnds = 1; // Selected Repeat Ends 0 -> Never 1 -> On Date 2 -> After Occurrenc;
        this.selectedEndsOn = new Date(); // Selected Ends on Dat;
        this.selectedEndsAfter = 1; // Selected value of Ends After Occurrenc;
        this.maxEndOn = null;
    }
}

export class SearchDataModel {
    totalResults: number;
    searchResults: Array<ViewMeetingsDetail>;
    filters: SearchFilters;
    searchKeyword: string;
    constructor() {
        this.totalResults = 0;
        this.searchResults = [];
        this.filters = new SearchFilters();
        this.searchKeyword = '';
    }
}
export class SearchFilters {
    startDate: string | null; // Start Date Selection for Date Picker
    endDate: string | null; // Start Date Selection for Date Picker
    meetingTypeIds: Array<number>;
    agendaPosted: boolean;
    minutesPosted: boolean;
    videoPosted: boolean;
    constructor() {
        this.startDate = null;
        this.endDate = null;
        this.meetingTypeIds = [];
        this.agendaPosted = false;
        this.minutesPosted = false;
        this.videoPosted = false;
    }
}

export interface SearchResultRequestModel {
    pageNo: number;
    pageSize: number;
    filter: SearchFilters;
    lastPage: boolean;
    searchKeyword: string;
}

export interface SearchResultReponseModel {
    searchResults: Array<ViewMeetingsDetail>;
    searchkeyword: string;
    totalElements: number;
}

export class SchedularDetailsModel {
    selectedDate: Date;
    meetingTypeIds: number[];
    isMobileMode: boolean;
    startDate: string;
    endDate: string;
    constructor() {
        this.selectedDate = new Date();
        this.meetingTypeIds = [-1];
        this.isMobileMode = false;
        this.startDate = '';
        this.endDate = '';
    }
}